'use client';
import { jsx as _jsx } from "react/jsx-runtime";
export const Option = ({ startIcon, index, ...props }) => (_jsx("option", { ...props }));
